export default "__VITE_ASSET__CPPP07Dj__"